import Footer from "../footer/Footer";
import HeaderTwo from "../header/HeaderTwo";


export default function PrivacyPolicy() {
    return (
        <>
        <HeaderTwo/>
        <div className="term-condition">
            <p>
            Privacy Policy
            Effective Date:06 Aug 2025
            Last Updated:06 Aug 2025

            At Obigin Media Labs LLP, we value your privacy and strive to protect your personal information when you use our games.

            1. Information We Collect
            Personal Information: Email, username, device ID (if applicable).

            Usage Data: Game progress, device type, crash reports, time spent.

            Payment Data: For in-app purchases via third-party processors (we do not store your card details).

            2. How We Use Your Information
            To improve game performance and user experience.

            To personalize features and rewards.

            To respond to support queries.

            To ensure a safe and fair environment.

            3. Cookies and Analytics
            We may use cookies or SDKs to understand gameplay behavior and improve features. Analytics data is aggregated and anonymized.

            4. Sharing of Information
            We do not sell your personal data. We may share data with:

            Third-party analytics providers.

            Payment gateways for transaction processing.

            Legal authorities if required by law.

            5. Children’s Privacy
            We do not knowingly collect data from children under 13. If you are a parent and believe your child has provided data, contact us for removal.

            6. Data Retention
            We retain user data only as long as necessary for game functionality, analytics, and legal compliance.

            7. Your Rights
            Depending on your location, you may have rights to access, correct, delete, or restrict your data. Contact us to exercise these rights.

            8. Security
            We implement industry-standard security measures, but no method of transmission is 100% secure.

            9. Changes to This Policy
            We may update this Privacy Policy periodically. Continued use of our games indicates your acceptance of changes.

            10. Contact
            For any privacy-related questions, email us at:
            [privacy@obigin.com]
            </p>
        </div>
      
        <Footer/>
        </>
    );
}